import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createBlock(_component_q_skeleton, { class: "attachment skeleton shaking-calm" }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "type" }, null, -1),
      _createElementVNode("span", { class: "name" }, null, -1)
    ])),
    _: 1
  }))
}